import React from "react";

import SupportCategory from "./Models/SupportCategory";
import {
  SupportCategoryTagWithHash,
  ScrollToCategoryTag,
} from "./SupportCategoryFunctions";

export interface FormProps {
  categories: SupportCategory[];
}

export type Props = FormProps;

// ColdFusion hard-coded all category information.  If the following correction is not made to the category name, the text will overflow out of bounds.
const fixCategoryName = (name: string) => {
  const newCategoryName = name;
  if (newCategoryName.toLowerCase() === "webstaurantplus") {
    return (
      <span>
        Webstaurant
        <br />
        Plus
      </span>
    );
  }

  return <span>{newCategoryName}</span>;
};

function SupportIcons({ categories }: Props) {
  return (
    <nav aria-label="question categories">
      <div className="support-subjects support-section clears cols-grid padded">
        {categories.map(
          (category) =>
            category.imageUrl && (
              <div
                key={category.id}
                className="cols-sm--3 cols-lg--2 cols-xl--2"
              >
                <a
                  href={SupportCategoryTagWithHash(category.categoryName)}
                  className="subject-link"
                  onClick={(e) => ScrollToCategoryTag(e, category.categoryName)}
                >
                  <img src={category.imageUrl} alt="" role="presentation" />
                  {fixCategoryName(category.categoryName)}
                </a>
              </div>
            )
        )}
      </div>
    </nav>
  );
}

export default SupportIcons;
